import { useTranslation } from 'react-i18next'
import { useCallback, useMemo } from 'react'

import { MonetaryVerificationsTableProps } from '../MonetaryVerificationTable.types'

import { MonetaryVerificationStatus } from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'
import { ALL_STATUSES_QUERY_VALUE, decodeStatuses } from './statusUtils'

export const useStatusesFilter = ({
  queryParams,
  setQueryParams
}: Pick<MonetaryVerificationsTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const statusesOptions = useMemo(
    () => [
      { label: t('table.pending'), value: MonetaryVerificationStatus.PENDING },
      { label: t('table.approved'), value: MonetaryVerificationStatus.APPROVED },
      { label: t('table.rejected'), value: MonetaryVerificationStatus.REJECTED },
      { label: t('table.expired'), value: MonetaryVerificationStatus.EXPIRED }
    ],
    [t]
  )

  const onStatusChange = useCallback(
    (statuses: string[]) =>
      setQueryParams({
        statuses: statuses.length ? statuses : [ALL_STATUSES_QUERY_VALUE]
      }),
    [setQueryParams]
  )

  return {
    statusesOptions,
    onStatusChange,
    selectedStatuses: decodeStatuses(queryParams.statuses ?? [])
  }
}
